import React from "react";
import "./KdsTableReference.css";

function KdsTableReference({ tableNumber, layoutName, showPrefix = false }) {
  const table = tableNumber == null ? "" : String(tableNumber).trim();
  const layout = layoutName == null ? "" : String(layoutName).trim();

  if (!table && !layout) return null;

  return (
    <span className="kds-table-reference" aria-label={[
      table && `${showPrefix ? "Table " : ""}${table}`,
      layout,
    ].filter(Boolean).join(", ")}>
      {table && (
        <span className="kds-table-reference__identifier">
          {showPrefix && <span className="kds-table-reference__prefix">Table</span>}
          {table}
        </span>
      )}
      {layout && (
        <span className="kds-table-reference__layout" title={layout}>
          {layout}
        </span>
      )}
    </span>
  );
}

export default KdsTableReference;
